import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPSERT_QUERY = print(gql`
  mutation UpsertCourse($data: UpsertCourseInput!) {
    upsertCourse(data: $data) {
      id
    }
  }
`);

export const responseUpdateKey = "upsertCourse";
export interface UpsertGql {
  upsertCourse: {
    id: number;
  };
}
